import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import PapperBlock from '../../../../components/PapperBlock/PapperBlock';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import TreeTable from '../../../../components/Tables/TreeTable';
import styles from './../reportes-jss'
import { LanguageConsumer, LanguageCxt } from './../../../../language/LanguageContext';

import IconButton from '@material-ui/core/IconButton';
//import Print from '@material-ui/icons/Print';

//Form
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import { renderInput, getSuggestions, renderSuggestion } from './../autocomplete'
import Downshift from 'downshift';
import Grid from '@material-ui/core/Grid';

import { apiPOST, returnCurrentUserId, returnCurrentUser } from '../../../../services/service_base';
import CloudDownload from '@material-ui/icons/CloudDownload';
import Loader from '../../../../components/Loader/Loader';
import classNames from 'classnames';
import moment from 'moment';
//import ReactToPrint from "react-to-print";

//import { CSVLink } from "react-csv";

const branch = 'searchsTree';

class ReporteConsultas extends Component {

  state = {
    //filters
    productor: 0,
    tituloObra: '',
    //Table
    data: { head: [], body: [] },
    //Catalogos
    producers: [],
    works: [],
    results: 0,
    //Loading
    isLoading: true,
    csvData: []
  }

  //Inputs
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleStateChange = changes => {
    if (changes.hasOwnProperty('selectedItem')) {
      this.setState({ tituloObra: changes.selectedItem })
    } else if (changes.hasOwnProperty('inputValue')) {
      this.setState({ tituloObra: changes.inputValue })
    }
  }

  //AHDA 18/02/2019
  handleClarFilters = () => {
    this.setState({
      productor: 0,
      tituloObra: '',
      isLoading: true
    })

    const request = {
      idProducer: 0,
      title: "0"
    }
    this.handleFetch(request);
  }

  //Download CSV
  handleDownload = (data) => {

    const currentUser = returnCurrentUser();
    const authorName = currentUser ? `${currentUser.nombre} ${currentUser.apellidos}` : '-';
    const generationDate = moment().format('DD/MM/YYYY HH:mm');
    const reportInfo = `"Autor:","${authorName}"\r\n"Fecha:","${generationDate}"\r\n\r\n`;
    const csvContent = data
      .map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
      .join('\r\n');
    const download = document.createElement("a"),
    blob = new Blob(["\ufeff" + reportInfo + csvContent], { type: 'text/csv;charset=utf-8;' });
    document.body.appendChild(download); //AHDA 23/05/2019
    download.href = window.URL.createObjectURL(blob);
    download.download = `Reporte_Obras_Mas_Consultadas_${moment().format('YYYYMMDD_HHmm')}.csv`;
    download.click();

    const body = {
      id_usuario: returnCurrentUserId(),
      user_action: 3,
      work_id: 0,
      portal: 'acervo',
      screen: 'reporteConsultas'
    }
    apiPOST('/audit/add', body);
  }

  //Llamada de busqueda
  searchs = () => {
    this.setState({ isLoading: true })

    const request = {
      idProducer: this.state.productor,
      title: this.state.tituloObra === "" ? "0" : this.state.tituloObra === "TODOS" ? "0" : this.state.tituloObra
    }

    //AHDA - 18/02/2019
    this.handleFetch(request);
  }

  ///JCMY 22/01/19
  componentDidMount() {

    //AHDA 
    //Get context for language and set titles 
    const { lang } = this.context;
    this.setState({
      data: {
        ...this.state.data,
        head: [
          { label: '', }, { label: lang.reports.title }, { label: lang.reports.author }, { label: lang.reports.producer }, { label: lang.reports.queryDate }, { label: lang.reports.totalSearchs }
        ]
      }
    });

    //Catalogo productores
    //AHDA 16/05/2019: Added valdation for refreshing
    apiPOST('/catalogue/get', { idCatalogo: 101 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ producers: response.data })
        }
      }
    )

    //AHDA - 18/02/2019
    //Catalogo obras
    //AHDA 16/05/2019: Added valdation for refreshing
    apiPOST('/catalogue/get', { idCatalogo: 16 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ works: response.data })
        }
      }
    )

    //Carga inicial
    const request = {
      idProducer: 0,
      title: "0"
    }

    //AHDA 18/02/2019
    this.handleFetch(request);
  }

  //AHDA 18/02/2019
  handleFetch = (body) => {
    apiPOST('/reports/rankingSearched', body).then(
      response => {
        this.setState({ isLoading: true })
        if (response.status === 200) {

          const result = [];
          const dataCsv = [["Id", "Título de la Obra", "Autor", "Productor", "Fecha de consulta", "Total de consultas"]];

          let rowNumber = 0;

          for (const x in response.data) {
            let obj = {};
            obj.id = response.data[x].id;
            obj.titulo = response.data[x].work_title;
            obj.autor = response.data[x].author || '-';
            obj.productor = response.data[x].productor;
            obj.fecha = response.data[x].last_date || '-';
            obj.consultas = response.data[x].total;

            const producers = [];

            for (const y in response.data[x].child) {
              const producer = {};
              producer.id = x + "_" + y;
              producer.titulo = response.data[x].work_title;
              producer.autor = response.data[x].author || '-';
              producer.productor = response.data[x].child[y].name;
              producer.fecha = response.data[x].child[y].date;
              producer.consultas = response.data[x].child[y].counter;
              producers.push(producer);


              const rowCsv = [];
              rowCsv.push(x + "_" + y);
              let cleanTitle = response.data[x].work_title;
              rowCsv.push(cleanTitle.replace(/,/g, ';'));
              rowCsv.push((response.data[x].author || '-').replace(/,/g, ';'));

              let cleanProducer = response.data[x].child[y].name;
              rowCsv.push(cleanProducer.replace(/,/g, ';'));
              rowCsv.push(response.data[x].child[y].date);
              rowCsv.push(response.data[x].child[y].counter);
              dataCsv.push(rowCsv);

            }
            obj.child = producers;
            result.push(obj);
          }
          this.setState({ data: { ...this.state.data, body: result }, isLoading: false, results: response.data.length, csvData: dataCsv })
        } else {
          this.setState({ openError: true, isLoading: false });
        }
      }
    ).catch(
      error => {
        this.setState({ openError: true, isLoading: false });
      }
    );
  }

  render() {
    const {
      classes
    } = this.props;
    return (
      <div className="marginTopLogo">
        <LanguageConsumer>
          {
            ({ lang }) =>
              <PapperBlock title={lang.reports.reports} whiteBg desc="">
                <form className={classes.container}>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <Grid item xs={12} sm={6} md={6}>
                      <FormControl className={classes.formControl}>
                        <Select value={this.state.productor} onChange={this.handleChange} name="productor" displayEmpty className={classes.selectEmpty}>
                          <MenuItem value={0}>{lang.reports.all}</MenuItem>
                          {
                            this.state.producers.map((producer, idx) =>
                              (
                                <MenuItem value={producer.value} key={`producer${idx}`}>{producer.data}</MenuItem>
                              ))
                          }
                        </Select>
                        <FormHelperText>{lang.reports.producer}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className={classes.positionRelative}>
                      {/*AHDA - 18/02/2019*/}
                      <div className={classes.root}>
                        <Downshift selectedItem={this.state.tituloObra} onStateChange={this.handleStateChange}>
                          {({
                            getInputProps,
                            getItemProps,
                            isOpen,
                            inputValue,
                            selectedItem,
                            highlightedIndex
                          }) => (
                              <div className={classes.formControl}>
                                {renderInput({
                                  fullWidth: true,
                                  classes,
                                  helperText: lang.reports.title,
                                  InputProps: getInputProps({
                                    placeholder: lang.reports.title,
                                    id: 'workTitle',
                                    name: 'workTitle',
                                  }),
                                })}
                                {isOpen ? (
                                  <Paper className={classNames(classes.paper, classes.list)} square>
                                    {getSuggestions(inputValue, this.state.works).map((suggestion, index) =>
                                      renderSuggestion({
                                        suggestion,
                                        index,
                                        itemProps: getItemProps({ item: suggestion.label }),
                                        highlightedIndex,
                                        selectedItem,
                                      }),
                                    )}
                                  </Paper>
                                ) : null}
                              </div>
                            )}
                        </Downshift>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <Grid item xs={12}>
                      <Button onClick={this.searchs} variant="contained" color="primary" className={classes.button}>
                        {lang.searchs.search}
                      </Button>
                      <Button variant="contained" color="primary" className={classes.button} onClick={this.handleClarFilters}>
                        Limpiar
                  </Button>
                    </Grid>
                  </Grid>
                </form>
                {
                  this.state.isLoading ?
                    <Loader text={"Cargando"} /> :
                    <Paper className={classes.rootTable} ref={el => (this.componentRef = el)}>
                      <div className={classes.headerTable}>
                        <Typography variant="title">{lang.reports.repMostSearchedWorks} ({this.state.results} {lang.reports.results})</Typography>
                        <div>
                          <Tooltip title={lang.reports.download} placement="bottom">
                            <IconButton aria-label="download" onClick={() => this.handleDownload(this.state.csvData)}>
                              <CloudDownload />
                            </IconButton>
                          </Tooltip>
                          {/* <Tooltip title={lang.reports.print} placement="bottom">
                            <IconButton aria-label="print">
                              <ReactToPrint trigger={() => <Print />} content={() => this.componentRef} />
                            </IconButton>
                          </Tooltip> */}
                        </div>
                      </div>
                      <TreeTable
                        dataTable={this.state.data}
                        branch={branch}
                      />
                    </Paper>
                }
              </PapperBlock>
          }
        </LanguageConsumer>
      </div>
    );
  }
}

ReporteConsultas.propTypes = {
  classes: PropTypes.object.isRequired
};

ReporteConsultas.contextType = LanguageCxt;

export default withStyles(styles)(ReporteConsultas);